var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.25V16.5C1.25 16.8315 1.3817 17.1495 1.61612 17.3839C1.85054 17.6183 2.16848 17.75 2.5 17.75H17.5C17.8315 17.75 18.1495 17.6183 18.3839 17.3839C18.6183 17.1495 18.75 16.8315 18.75 16.5V5.25H1.25ZM12.5 8.53125C12.5 8.65557 12.4506 8.7748 12.3627 8.86271C12.2748 8.95061 12.1556 9 12.0312 9H7.96875C7.84443 9 7.7252 8.95061 7.63729 8.86271C7.54939 8.7748 7.5 8.65557 7.5 8.53125V8.21875C7.5 8.09443 7.54939 7.9752 7.63729 7.88729C7.7252 7.79939 7.84443 7.75 7.96875 7.75H12.0312C12.1556 7.75 12.2748 7.79939 12.3627 7.88729C12.4506 7.9752 12.5 8.09443 12.5 8.21875V8.53125Z",
    fill: "#668598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 1.5V3.375C20 3.54076 19.9342 3.69973 19.8169 3.81694C19.6997 3.93415 19.5408 4 19.375 4H0.625C0.45924 4 0.300269 3.93415 0.183058 3.81694C0.065848 3.69973 0 3.54076 0 3.375V1.5C0 1.16848 0.131696 0.850537 0.366117 0.616116C0.600537 0.381696 0.918479 0.25 1.25 0.25H18.75C19.0815 0.25 19.3995 0.381696 19.6339 0.616116C19.8683 0.850537 20 1.16848 20 1.5Z",
    fill: "#668598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjects);
export default __webpack_public_path__ + "static/media/IconProjects.5e17f56e57440012b0fe87a20cf49a93.svg";
export { ForwardRef as ReactComponent };